import { useParams } from 'js/lib/useRouter';

import type { AdminType, EnterpriseAdminAccountProperties, EnterpriseProperties } from '@coursera/event-pulse-types';

import { useEnterpriseAdminContext } from 'bundles/enterprise-admin/EnterpriseAdminContext';

export type EnterpriseAdminTrackingDataType = {
  enterprise: EnterpriseProperties;
  enterpriseAdminAccount: EnterpriseAdminAccountProperties;
};

export const useEnterpriseAdminTrackingData = (): EnterpriseAdminTrackingDataType => {
  const { adminRoleType } = useEnterpriseAdminContext();
  const { thirdPartySlug, programSlug } = useParams();
  return {
    enterprise: {
      organizationSlug: thirdPartySlug,
      programSlug,
    },
    enterpriseAdminAccount: {
      adminType: (adminRoleType ? adminRoleType.toLowerCase().replace(/ /g, '_') : undefined) as AdminType,
    },
  };
};
